import { DateTime } from 'luxon';
import React, { useState } from 'react'
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import ApexChart from '../../ApexCharts/ApexChart';

function KpiItem({ 
    id, valueId, title, cardClass, valueClasses, 
    popoverTitle,
    compareClass, valueComponent, overrideLine, 
    description, prefix, suffix, value, secondaryStats, 
    localeFormatted, prevValue, miniStats, plottedItems, 
    compareDownStyle, compareUpStyle, showFbWarning, 
    visualComponent, overrideTheme }){
    const [popoverOpen, setPopoverOpen] = useState(false);

    const toggle = () => setPopoverOpen(!popoverOpen);

    let compareValue = false
    let valueDiff = 0
    
    if(prevValue > 0 && value > 0){
        compareValue = true

        if(prevValue > value){
            valueDiff = ((1 - value / prevValue) * 100).toFixed(0)
        } else {
            valueDiff = ((1 - prevValue / value) * 100).toFixed(0)
        }
    }

    const responsive = [{
        breakpoint: 1500,
        options: {
            chart: {
                width: 120
            }
        }
    },{
        breakpoint: 1300,
        options: {
            chart: {
                width: 100
            }
        }
    },{
        breakpoint: 1200,
        options: {
            chart: {
                width: 160
            }
        }
    },{
        breakpoint: 900,
        options: {
            chart: {
                width: 120
            }
        }
    },{
        breakpoint: 576,
        options: {
            chart: {
                width: 180
            }
        }
    },{
        breakpoint: 400,
        options: {
            chart: {
                width: 120
            }
        }
    }]

    let popId = `pop${title.replace( /[^a-zA-Z0-9 ]*/ig, '').replace(/ /g, "")+parseInt(value)}`

    return <div className={`card border-0 text-truncate mb-3 ${cardClass}`} id={id !== null ? id : DateTime.local().toMillis().toString()}>
    <div className="card-body">
        <div className="row d-flex justify-content-between" style={{height:"30px"}}>
            <div className="col-sm-6 col mb-1 f-s-16">
                <b className="mb-3" dangerouslySetInnerHTML={{
                    __html: title
                }}></b> 
                <span id={popId} className="ml-2" >
                    <i className="fa fa-info-circle"></i>
                </span>
                <Popover trigger="click" placement="top" isOpen={popoverOpen} target={popId} toggle={toggle}>
                <PopoverHeader dangerouslySetInnerHTML={{
                        __html: popoverTitle ? popoverTitle : title
                    }}></PopoverHeader>
                    <PopoverBody>{description}</PopoverBody>
                </Popover>
            </div>
            {visualComponent && <div className="col-sm-6 col mb-1 f-s-16 visual-component">
                {visualComponent}
            </div>}
            {showFbWarning && <a target="_blank" className="col text-right" href="https://www.facebook.com/business/help/331612538028890?id=428636648170202">
                <i className="text-danger fa fa-info-circle"></i>
            </a>}
        </div>
        <div className="d-flex align-items-center mb-1">
            <h1 className={`mb-0 font-weight-bold ${valueClasses}`}>
                {prefix || ""}<span data-animation="number" data-value={value} {...(valueId ? ({id: valueId}) : {})}>{localeFormatted ? parseInt(value).toLocaleString() : value}</span>{suffix}
            </h1>
            <div className={`ml-auto text-black`}>
                {valueComponent ? valueComponent : plottedItems.length > 0 && <ApexChart
                    overrideTheme={overrideTheme}
                    options={{
                        chart: {
                            sparkline: {
                                enabled: true
                            }
                        },
                        grid: {
                            show: false,
                            row: {
                                colors: [],
                                opacity: 0.5
                            }
                        },
                        tooltip: {
                            fixed: {
                                enabled: false
                            },
                            x: {
                                show: true
                            },
                            y: {
                                title: {
                                formatter: function (seriesName) {
                                    return ''
                                }
                                }
                            },
                            marker: {
                                show: false
                            }
                        },
                        stroke: {
                            show: true,
                            width: 3 
                        },
                        responsive,
                        fill: {
                            type: 'gradient',
                            gradient: {
                                opacityFrom: 1,
                                opacityTo: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: "#ff5b57",
                                    opacity: 1
                                },
                                {
                                    offset: 50,
                                    color: "#f59c1a",
                                    opacity: 1
                                },
                                {
                                    offset: 100,
                                    color: "#90ca4b",
                                    opacity: 1
                                }]
                            },
                        },
                        
                    }}
                    series= {plottedItems}
                    type="line"
                    width="160"
                    height="35"
                />}
            </div>
        </div>
        {overrideLine && <hr className="bg-grey" />}
        {compareValue ? <div className={`mb-1 font-weight-bold ${prevValue > value ? compareDownStyle: compareUpStyle}`}>
            <i className={`${prevValue > value ? "fa fa-caret-down": "fa fa-caret-up"}`}></i> 
            <span data-animation="number" data-value={valueDiff}>{valueDiff}</span>% vs last period
        </div> : <></>}
        {(miniStats && miniStats.length > 0) && <hr className="bg-grey" />}
        {miniStats && miniStats.map((stat, k) => {
            let compareValue = false
            let valueDiff = 0
            
            if(stat.type === "compare" && stat.prevValue > 0 && stat.value > 0){
                compareValue = true
        
                if(stat.prevValue > stat.value){
                    valueDiff = ((1 - stat.value / stat.prevValue) * 100).toFixed(0)
                } else {
                    valueDiff = ((1 - stat.prevValue / stat.value) * 100).toFixed(0)
                }
                
            } else if(stat.type === "secondary") {
                compareValue = true
                valueDiff = stat.secondary
            } else if(!stat.type && value > 0 && stat.value > 0){
                compareValue = true
        
                valueDiff = ((stat.value / value) * 100).toFixed(0)
            }


            return <div className={`d-flex mb-${k === miniStats.length - 1 ? '0' : '2'}`}>
                <div className="caps d-flex align-items-center">
                    <i className={`fa fa-circle f-s-8 mr-2 ${stat.color}`}></i>
                    {stat.title}
                </div>
                <div className="d-flex align-items-center ml-auto">
                    {compareValue && <div className="text-grey f-s-11">
                        {stat.type === "compare" && <i className={stat.prevValue > stat.value ? "fa fa-caret-down": "fa fa-caret-up"}></i>}  
                        <span data-animation="number" data-value={valueDiff}>{valueDiff}</span>%
                    </div>}
                    <div className="width-50 text-right pl-2 f-w-600">
                        <span data-animation="number" data-value={stat.value}>{stat.value}</span>{stat.suffix}
                    </div>
                </div>
                
            </div>
        })}
        {secondaryStats.length > 0 && <>
            <hr className="bg-grey" />
            <div className="row text-truncate">
                {secondaryStats.map((stat,key) => {
                    let cVal = false
                    let vDiff = 0

                    if(stat.prevValue && stat.prevValue > 0 && stat.value > 0){
                        cVal = true
                
                        if(stat.prevValue >= stat.value){
                            vDiff = ((1 - stat.value / stat.prevValue) * 100).toFixed(0)
                        } else {
                            vDiff = ((1 - stat.prevValue / stat.value) * 100).toFixed(0)
                        }
                    }

                    return <div key={key} className="col-sm-6 col-12">
                        <div className="f-s-16 font-weight-bold">
                            {stat.title} {stat.showFbWarning && <a target="_blank" href="https://www.facebook.com/business/help/331612538028890?id=428636648170202">
                                <i className="text-danger fa fa-info-circle"></i>
                            </a>}
                        </div>
                        <h2 style={{
                            fontSize:"24px"
                        }} className="m-b-5 f-w-600 p-b-1" data-animation="number" data-value={stat.value}>
                            {stat.prefix || ""}<span {...(stat.id ? {id: stat.id} : {})}>{stat.value?.toLocaleString()}</span>{stat.suffix || ""}
                        </h2>
                        
                        {cVal ? <div className={`font-weight-bold ${stat.prevValue > stat.value ? "text-danger": "text-vibe-green"}`}>
                            <i className={stat.prevValue > stat.value ? "fa fa-caret-down": "fa fa-caret-up"}></i> 
                            <span data-animation="number" data-value={vDiff}>{vDiff}</span>% vs last period
                        </div> : <></>}
                    </div>
                })}
            </div>
        </>}
    </div>
</div>
}

KpiItem.defaultProps = {
    id: null,
    title: "",
    popoverTitle: null,
    valueId: null,
    plottedItems: [],
    secondaryStats: [],
    visualComponent: null,
    valueComponent: null,
    localeFormatted: false,
    overrideLine: false,
    valueClasses:"",
    cardClass: "",
    compareClass: null,
    overrideTheme: null,
    compareDownStyle: "text-danger",
    compareUpStyle: "text-vibe-green"
}

export default KpiItem